/**
 * Filter
 */

export default function HWY_Filter() {
    this.init = () => {
        jQuery(document).on(
            "click",
            ".filter-categories-header .category-close",
            function () {
                jQuery(".shop-filter .filter-control").removeClass("active");
            }
        );
        jQuery(document).on(
            "click",
            ".c7-collection-filter-bar-mobile-toggle",
            function () {
                jQuery(".shop-filter .filter-control").addClass("active");
            }
        );

        // jQuery(window).on("load", function () {
        //   const paramsString = window.location.search;
        //   const searchParams = new URLSearchParams(paramsString);
        //   if (searchParams.has("filter")) {
        //     const filter = searchParams.get("filter");
        //     const getElementFilter = jQuery("[data-filter]").filter(function () {
        //       return jQuery(this).data("filter") === filter;
        //     })[0];
        //     jQuery(getElementFilter).find(".accordion-src").trigger("click");
        //     const offsetShopFilter = jQuery(".shop-filter").offset();
        //     jQuery("html, body").animate({ scrollTop: offsetShopFilter.top }, 400);
        //   } else {
        //     const selector = jQuery("[data-filter]")[0];
        //     jQuery(selector).find(".accordion-src").trigger("click");
        //   }
        // });
    };
}
